export default {
    inserted(el, binding, vnode) {
        function resize(){
            if (!el ) return;
            var rr=el.getBoundingClientRect();
            var x9;    
            var el2=document.getElementById("mainfooter");
            if (el2) {
                var x2=el2.getBoundingClientRect();
                x9=x2.top-rr.top-2;
                
            } else {
                x9=window.innerHeight-rr.top-2 ;		    
            }
            el.style.height=x9+"px"
        };
        el.mydata=resize;
        window.addEventListener('resize', el.mydata);
        resize();
        el.focus()
       
    },
    unbind(el) {
        window.removeEventListener('resize', el.mydata);
        delete el.mydata;
    }

}




// WEBPACK FOOTER //
// ./src/_eng/directives/filltoend.js